import React, {useEffect, useState} from "react";
import axios from 'axios';
import { Spin } from 'antd';

import CustomButton from '../common/button/CustomButton';
import { isMobile } from 'react-device-detect';
import qrcode from '../../../static/media/app-store/qr-code-simple.png'



export const getCsrfToken = () => {
    const csrf = document.cookie.match('(^|;)\\s*csrftoken\\s*=\\s*([^;]+)');
    return csrf ? csrf.pop() : '';
  };



export default function ActivatePage(props) {

  const [error, seterror] = useState()

  const  activate_user = () => {
    const config = {
        headers: {
            'Content-Type': 'application/json',
            'X-CSRFToken' : getCsrfToken()
        }
    };

    const body ={"uid": props.match.params.uid, "token": props.match.params.token};

    axios.post('/auth/users/activation/', body, config).then(function (response) {
        response.data;
        seterror(false)
      })
      .catch(function (error) {
        console.log(error.response.status)
        seterror(true)
      });

    }

      useEffect(() => {
        activate_user()
        // seterror(false)
      }, [])

  return (
    <>


 <div className="container row2" style={{width:'100%',
  justifyContent:'center', textAlign:'center',
  alignItems:'center', marginLeft:'5%'
}}>
    <div    
     className='full-site'
     style={{zIndex:10}}
    >

    <div>

    {
      
      error ?
   <> 
   <h2 style={{marginTop:'5%'}}>Expired link</h2>
<p style={{textAlign:'center'}}>This activation link has expired or is invalid.
{isMobile ?null: <br/>}
      {isMobile ?null: 'Scan to open Inner Reef.'}
</p>

<div style={{ width:'100%',      justifyContent: 'center',
      alignItems: 'center',  textAlign:'center'}}>
        {isMobile ?

        <CustomButton href={'/open'} color={'pastel'} title={'OPEN APP'}/>

        :  <div style={{width:'100%', textAlign:'center', justifyContent:'center',alignItems:'center'}}>
        
        <img src={qrcode} 
        style={{
           width:'40%',
          height: 'auto',
          maxWidth:'250px',
       }}
       /></div>}
        </div> 
</>    
      :
      error==false ?
     <div style={{justifyContent:'center', alignItems:'center', alignSelf:'center',
   minHeight:'250px',textAlign:'center'}}> 
      <h2 style={{marginTop:'5%'}}>Thank you for activating your account</h2>
      <p style={{textAlign:'center'}}>You're now ready to play the Inner Reef game!
      {isMobile ?null: <br/>}
      {isMobile ?null: 'Scan to open the Inner Reef game.'}</p>
     <div style={{ width:'100%',      justifyContent: 'center',
      alignItems: 'center',  textAlign:'center'}}>
        {isMobile ?
        <CustomButton href={'/open'} color={'bright'}
       title={'OPEN GOALQUEST'}
       largebutton={true}/>
       :  
       <div style={{width:'100%', textAlign:'center', justifyContent:'center',alignItems:'center',textAlign:'center'}}>
       <img src={qrcode} 
       style={{
          width:'40%',
         height: 'auto',
         maxWidth:'250px',
      }}
      /></div>}
       </div> 
      </div>
      :
      <div style={{justifyContent:'center', alignItems:'center', alignSelf:'center',
      paddingTop:'10%', width:'100%',textAlign:'center'}}> 
      <Spin size="large" 
      style={{ minHeight:'250px'}}
      />
      </div>
    }
    </div>               
    </div>
    </div>
    </>
  )
}





